(function (ws, win) {
    'use strict';
    ws.views.productfilterpage = ws.views.googleAnalytics.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'catalog',
        FACET_CATEGORY: 'refine by categories',
        FACET_VENDOR: 'refine by vendor',

        /**
         * event handlers
         */
        events: {
            'click .select-all': 'filterAll',
            'click .cpf-filter-clear-all': 'clearAll',
            'click .apply-filter': 'refreshList',
            'change #searchOnField': 'refreshListCheck',
            'change #searchType': 'refreshListCheck',
            'click .tag-label': 'removeTag',
            'click .custom-checkbox': 'enableApplyButton'
        },

        /**
         * Initialize
         */
        initialize: function () {
            $(window).on('resize load', this.updateCSS);
            this.$selectedCountryCode = this.$('#selectedCountryCode').val();
            this.$pageIdentity = this.$('#pageIdentity').val();
            this.sortOrder = this.$('.cpf-sort').val();
            this.pageSize = this.$('.cpf-page-size').val();

            // jscs:disable
            $(document).foundation();
            Foundation.Accordion.defaults.multi_expand = true;
            // jscs:enable
            this.render();
        },

        render: function () {
            this.updateSearchQuery();
        },

        updateSearchQuery: function () {
            let searchQuery;
            if ($('#searchText').val()) {
                searchQuery = $('#searchText').val().toLocaleUpperCase() + ':relevance:vendorProducts:' + $('#selectedCountryCode').val() + ':productSalesOrgList:' + $('#selectedCountryCode').val();
            } else {
                searchQuery = $('#searchText').val() + ':relevance:vendorProducts:' + $('#selectedCountryCode').val() + ':productSalesOrgList:' + $('#selectedCountryCode').val();
            }

            var $checkboxes = $('.custom-checkbox');
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).prop('checked') === true && $(checkbox).prop('disabled') !== true) {
                    if ($(checkbox).data('facetcode') === 'categories') {
                        searchQuery = searchQuery + ':categories:' + $(checkbox).val();
                    } else if ($(checkbox).data('facetcode') === 'vendor') {
                        searchQuery = searchQuery + ':vendor:' + $(checkbox).val();
                    } else if ($(checkbox).data('facetcode') === 'isIntangible') {
                        searchQuery = searchQuery + ':isIntangible:' + $(checkbox).val();
                    }
                }
            });

            $('.searchQueryPagination').val(searchQuery.replace(/ /g, '+'));
            $('.cpf-sort-code').val($('.cpf-sort').val());
        },

        refreshListCheck: function () {
            if ($('#searchText').val() != undefined && $('#searchText').val().trim() != '') {
                $('#applyFilter').val('false');
                $('#searchFilter').val('true');
                this.refreshList();
            }
        },

        /**
         *  Enable the download button and disable Download Button
         */
        enableApplyButton: function (e) {
            let $target = $(e.target);
            var $checkboxes = $(e.target).parent().parent().find('.custom-checkbox');

            var flag = 1;
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).is(':checked')) {
                    $target.parent().parent().parent().find('.apply-filters').attr('disabled', false);
                    $target.parent().parent().parent().find('.disablebutton').addClass('apply-filter');
                    $target.parent().parent().parent().find('.apply-filters').removeClass('disablebutton');
                    flag = 0;
                }
            });

            if (flag === 1) {
                $target.parent().parent().parent().find('.apply-filters').attr('disabled', true);
                $target.parent().parent().parent().find('.apply-filters').addClass('disablebutton');
                $target.parent().parent().parent().find('.disablebutton').removeClass('apply-filter');
            }

        },

        /**
         * Resize window css
         */
        updateCSS: function () {
            $('.cpf-sub-accordian li,.cpf-sub-accordian li div').toggleClass('active', $(window).width() > 1024);
        },

        removeTag: function () {
            $('.searchedTextDiv').hide();
            $('#searchText').val('');
            $('#applyFilter').val('false');
            location.href = sitePath + '/productcatalog?q=';
        },

        /**
         * Refresh List on change
         * @param {Object} e
         */
        refreshList: function (e) {
            let _this = this;
            let searchQuery;
            if ($('#searchText').val()) {
                searchQuery = $('#searchText').val().toLocaleUpperCase() + ':relevance:vendorProducts:' + this.$('#selectedCountryCode').val() + ':productSalesOrgList:' + this.$('#selectedCountryCode').val();
            } else {
                searchQuery = $('#searchText').val() + ':relevance:vendorProducts:' + this.$('#selectedCountryCode').val() + ':productSalesOrgList:' + this.$('#selectedCountryCode').val();
            }

            var $checkboxes = $('.custom-checkbox');
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).prop('checked') === true && $(checkbox).prop('disabled') !== true) {
                    if ($(checkbox).data('facetcode') === 'categories') {
                        searchQuery = searchQuery + ':categories:' + $(checkbox).val();
                    } else if ($(checkbox).data('facetcode') === 'vendor') {
                        searchQuery = searchQuery + ':vendor:' + $(checkbox).val();
                    } else if ($(checkbox).data('facetcode') === 'isIntangible') {
                        searchQuery = searchQuery + ':isIntangible:' + $(checkbox).val();
                    }
                }
            });

            let $form = $('#filter_form');

            if ($('#searchText').val() == '') {
                $('#searchOnFieldValue').val('');
                $('#searchTypeValue').val('');
            } else {
                $('#searchOnFieldValue').val($('#searchOnField').val());
                $('#searchTypeValue').val($('#searchType').val());
            }

            $('#searchQuery').val(searchQuery.replace(/ /g, '+'));
            if ($('.sizeOptions').val() != undefined) {
                $('#pageSizeValue').val($('.sizeOptions').val());
            }

            $('#sortCodeValue').val($('.sortOptions').val());
            $form.submit();
        },

        /**
         * Redirects to select all/clear all search query
         * @param {Object} e
         */
        filterAll: function(e) {
            e.preventDefault();
            e.stopPropagation();
            var $target = $(e.target);

            var $checkboxAll = $target.parent().parent().parent().children('ul').children('li').children('.custom-checkbox');
            _.each($checkboxAll, function(checkbox) {
                $(checkbox).prop('checked', true);
            });

            $target.parent().parent().parent().find('.apply-filters').attr('disabled', false);
            $target.parent().parent().parent().find('.disablebutton').addClass('apply-filter');
            $target.parent().parent().parent().find('.apply-filters').removeClass('disablebutton');
        },

        /**
         * Redirects to clear all search query
         * @param {Object} e
         */
        clearAll: function(e) {
            e.preventDefault();
            e.stopPropagation();
            var $target = $(e.target);

            var $checkboxAll = $target.parent().parent().parent().children('ul').children('li').children('.custom-checkbox');
            _.each($checkboxAll, function(checkbox) {
                $(checkbox).prop('checked', false);
            });

            $target.parent().parent().parent().find('.apply-filters').attr('disabled', true);
            $target.parent().parent().parent().find('.apply-filters').addClass('disablebutton');
            $target.parent().parent().parent().find('.disablebutton').removeClass('apply-filter');
        }
    });
})(westcon, window);
